<script>
  export let flip = false;
  export let fitHeight = false;
  export let rotate = false;
</script>

<svg
  class:fitHeight
  class:rotate
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  {#if flip}
    <path
      d="M4 4L17 10.5L4 17"
      stroke="black"
      stroke-width="1.5"
      stroke-linejoin="bevel"
    />
  {:else}
    <path
      d="M17 4L4 10.5L17 17"
      stroke="black"
      stroke-width="1.5"
      stroke-linejoin="bevel"
    />
  {/if}
</svg>

<style>
  svg.fitHeight {
    height: 100%;
    width: auto;
  }
  svg.rotate {
    rotate: 90deg;
  }
</style>
